/* eslint-disable max-lines */
import { ColumnOptionType } from "./types";
import { DatapointIdStandardEnum, EntityType } from "api/ux/src";
import { DetailsPanelType, DimensionSelectorEntityType, WidgetType } from "components/modal/widget-workshop/types";
import { language } from "language/default";
import { DataGranularity, DataGranularityType, DataScale, DisplayValueType, SortByTypes } from "store/current-dashboard/types";
export const WidgetWorkshopInitialState = {
    editor: {
        detailPanels: {
            [DetailsPanelType.AddColumn]: { type: DetailsPanelType.AddColumn },
            [DetailsPanelType.Settings]: { type: DetailsPanelType.Settings },
            [DetailsPanelType.GroupSettings]: { type: DetailsPanelType.GroupSettings },
            [DetailsPanelType.GroupOptions]: { type: DetailsPanelType.GroupOptions },
            [DetailsPanelType.Filters]: { type: DetailsPanelType.Filters }
        },
        preview: { widget: {
                componentName: "InsDatapointGridWidget",
                componentProps: { columnsTemplate: { columns: [
                            {
                                columnOptionType: ColumnOptionType.GroupingColumn,
                                enableRowGroup: true,
                                field: "CustomGroup",
                                headerName: "Top-Bottom Group",
                                hide: true,
                                type: "insNumberColumn"
                            }
                        ] },
                    datapointParams: [{}],
                    pipelineParameter: { compositeObjectBuilder: { options: { getMeasuresAndDimensionsFromDatapointParams: true } },
                        customVisitorsReducer: [
                            {
                                method: "gridTopFilter"
                            }
                        ],
                        nodesVisitorsReducer: [] },
                    userSettings: { dataGranularity: DataGranularity.quarterly } }
            } },
        settings: { data: { columns: { options: [] } } },
        showNotification: true
    },
    header: { widgetType: 0 }
};
export const defaultMeasureDimensionByEntity = {
    [EntityType.Portfolio]: { dimensions: [
            {
                name: "Id",
                standardDatapoint: "Portfolio.PortfolioId"
            }
        ],
        measures: [] },
    [EntityType.Manager]: { dimensions: [
            {
                name: "Id",
                standardDatapoint: "Manager.ManagerId"
            }
        ],
        measures: [] },
    [EntityType.FundSeries]: { dimensions: [
            {
                name: "Id",
                standardDatapoint: "FundSeries.Id"
            }
        ],
        measures: [] },
    [EntityType.Fund]: { dimensions: [
            {
                name: "Id",
                standardDatapoint: "Fund.FundId"
            }
        ],
        measures: [] },
    [EntityType.Asset]: { dimensions: [
            {
                name: "Id",
                standardDatapoint: "Asset.AssetId"
            }
        ],
        measures: [] },
    [DimensionSelectorEntityType.Instrument]: { dimensions: [
            {
                name: "Id",
                standardDatapoint: "Instrument.InstrumentId"
            }
        ],
        measures: [] },
    [DimensionSelectorEntityType.InvestorAccount]: { dimensions: [
            {
                name: "Fund.InvestorId",
                standardDatapoint: "Fund.InvestorId"
            },
            {
                name: "Fund.FundId",
                standardDatapoint: "Fund.FundId"
            }
        ],
        measures: [] },
    [DimensionSelectorEntityType.Market]: { dimensions: [
            {
                name: "Id",
                standardDatapoint: "Market.MarketId"
            }
        ],
        measures: [] }
};
export const defaultComparisonMeasureName = "ComparateName";
export const defaultComparisonMeasureByEntity = {
    [EntityType.Portfolio]: {
        name: defaultComparisonMeasureName,
        standardDatapoint: DatapointIdStandardEnum.PortfolioPortfolioName
    },
    [EntityType.Manager]: {
        name: defaultComparisonMeasureName,
        standardDatapoint: DatapointIdStandardEnum.ManagerManagerName
    },
    [EntityType.Fund]: {
        name: defaultComparisonMeasureName,
        standardDatapoint: DatapointIdStandardEnum.FundFundName
    },
    [EntityType.FundSeries]: {
        name: defaultComparisonMeasureName,
        standardDatapoint: DatapointIdStandardEnum.FundSeriesName
    },
    [EntityType.Asset]: {
        name: defaultComparisonMeasureName,
        standardDatapoint: DatapointIdStandardEnum.AssetAssetName
    },
    [EntityType.Market]: {
        name: defaultComparisonMeasureName,
        standardDatapoint: DatapointIdStandardEnum.FundBenchmarkName
    }
};
export const WorkShopInitialStateByType = {
    [WidgetType.Grid]: (entity) => ({
        componentName: "InsDatapointGridWidget",
        componentProps: { columnsTemplate: { columns: [
                    {
                        columnOptionType: ColumnOptionType.GroupingColumn,
                        enableRowGroup: true,
                        field: "CustomGroup",
                        headerName: "Top-Bottom Group",
                        hide: true,
                        type: "insNumberColumn"
                    }
                ] },
            datapointParams: [defaultMeasureDimensionByEntity[entity] ?? {}],
            pipelineParameter: { compositeObjectBuilder: { options: { getMeasuresAndDimensionsFromDatapointParams: true } },
                customVisitorsReducer: [
                    {
                        method: "gridTopFilter"
                    }
                ],
                nodesVisitorsReducer: [] },
            userSettings: { dataScale: DataScale.million } }
    }),
    [WidgetType.KPI]: (entity) => ({
        componentName: "InsKpiDatapointWidget",
        componentProps: { colorSet: "default",
            comparisonChartType: "InsWaterfallComparisonChart",
            comparisonComponentName: "InsChartWidget",
            datapointParams: [defaultMeasureDimensionByEntity[entity]],
            inverted: true,
            pipelineParameter: { comparisonVisitorsReducer: [],
                compositeObjectBuilder: { measures: [] },
                customVisitorsReducer: [],
                nodesVisitorsReducer: [] },
            showLegend: true,
            userSettings: { dataGranularity: DataGranularity.quarterly,
                dataGranularityTitle: language.en.skeleton.settingsMenu.granularity.granularity,
                dataGranularityType: DataGranularityType.Variation } }
    }),
    [WidgetType.ValuePair]: (entity) => ({
        componentName: "InsValuePairDatapointWidget",
        componentProps: { datapointParams: [defaultMeasureDimensionByEntity[entity]],
            pipelineParameter: { compositeObjectBuilder: { options: { getMeasuresAndDimensionsFromDatapointParams: true } },
                customVisitorsReducer: [
                    {
                        arguments: [],
                        method: "valuePair"
                    }
                ],
                nodesVisitorsReducer: [] },
            userSettings: { dataScale: DataScale.million } }
    }),
    [WidgetType.Bar]: (entity) => ({
        componentName: "InsChartWidget",
        componentProps: { chartType: "insHorizontalBarDatapointChart",
            colorSet: "default",
            comparisonChartType: "insHorizontalBarComparisonChart",
            comparisonComponentName: "InsChartWidget",
            datapointParams: [{ dimensions: [], measures: [] }],
            pipelineParameter: {
                comparisonVisitorsReducer: [
                    {
                        arguments: [defaultComparisonMeasureByEntity[entity]?.name ?? defaultComparisonMeasureName],
                        method: "groupHighchartsOneMeasure"
                    }
                ],
                compositeObjectBuilder: {
                    dimensions: [],
                    measures: []
                },
                customVisitorsReducer: [
                    {
                        arguments: [],
                        method: "highchartsOneMeasure"
                    }
                ],
                datapointsVisitorsReducer: [
                    {
                        arguments: [],
                        method: "sortByDatapoint"
                    }
                ],
                nodesVisitorsReducer: [
                    {
                        arguments: [],
                        method: "addMinValueVisitor"
                    },
                    {
                        arguments: [],
                        method: "addMaxValueVisitor"
                    },
                    {
                        arguments: [],
                        method: "addTotalPercentageToLeafVisitor"
                    },
                    {
                        arguments: [],
                        method: "addFormattedValueVisitor"
                    },
                    {
                        arguments: [],
                        method: "addFormattedValueVisitor"
                    }
                ]
            },
            userSettings: {
                chartTypeAvailable: "SingleDimension",
                displayOptions: {
                    showScale: true,
                    showTotals: true
                },
                displayValueType: DisplayValueType.Numeral,
                shownValues: {
                    filter: "all"
                },
                sortBy: SortByTypes.Name
            },
            userSettingsForComparision: {
                displayOptions: {
                    showScale: true,
                    showTotals: true
                },
                displayValueType: DisplayValueType.Numeral
            } }
    }),
    [WidgetType.Donut]: (entity) => ({
        componentName: "InsChartWidget",
        componentProps: { chartType: "InsDonutChart",
            colorSet: "default",
            comparisonChartType: "insHorizontalBarComparisonChart",
            comparisonComponentName: "InsChartWidget",
            datapointParams: [{ dimensions: [], measures: [] }],
            pipelineParameter: {
                comparisonVisitorsReducer: [
                    {
                        arguments: [defaultComparisonMeasureByEntity[entity]?.name],
                        method: "groupHighchartsOneMeasure"
                    }
                ],
                compositeObjectBuilder: {
                    dimensions: [],
                    measures: []
                },
                customVisitorsReducer: [
                    {
                        arguments: [],
                        method: "highchartsOneMeasure"
                    }
                ],
                datapointsVisitorsReducer: [
                    {
                        arguments: [],
                        method: "sortByDatapoint"
                    }
                ],
                nodesVisitorsReducer: [
                    {
                        arguments: [],
                        method: "addMinValueVisitor"
                    },
                    {
                        arguments: [],
                        method: "addMaxValueVisitor"
                    },
                    {
                        arguments: [],
                        method: "addFormattedValueVisitor"
                    },
                    {
                        arguments: [],
                        method: "addFormattedValueVisitor"
                    }
                ]
            },
            userSettings: {
                chartTypeAvailable: "SingleDimension",
                displayOptions: {
                    showScale: true,
                    showTotals: true
                },
                displayValueType: DisplayValueType.Numeral,
                shownValues: {
                    filter: "all"
                },
                sortBy: SortByTypes.Value
            },
            valueFormat: 3 }
    }),
    [WidgetType.Surface]: (entity) => ({
        componentName: "InsChartWidget",
        componentProps: { chartType: "InsTreeMapChart",
            colorSet: "default",
            comparisonChartType: "insHorizontalBarComparisonChart",
            comparisonComponentName: "InsChartWidget",
            datapointParams: [{ dimensions: [], measures: [] }],
            pipelineParameter: {
                comparisonVisitorsReducer: [
                    {
                        arguments: [defaultComparisonMeasureByEntity[entity]?.name],
                        method: "groupHighchartsOneMeasure"
                    }
                ],
                compositeObjectBuilder: {
                    dimensions: [],
                    measures: []
                },
                customVisitorsReducer: [
                    {
                        arguments: [],
                        method: "highchartsOneMeasure"
                    }
                ],
                datapointsVisitorsReducer: [
                    {
                        arguments: [],
                        method: "sortByDatapoint"
                    }
                ],
                nodesVisitorsReducer: [
                    {
                        arguments: [],
                        method: "addMinValueVisitor"
                    },
                    {
                        arguments: [],
                        method: "addMaxValueVisitor"
                    },
                    {
                        arguments: [],
                        method: "addFormattedValueVisitor"
                    },
                    {
                        arguments: [],
                        method: "addFormattedValueVisitor"
                    }
                ]
            },
            userSettings: {
                chartTypeAvailable: "SingleDimension",
                displayOptions: {
                    showScale: true,
                    showTotals: true
                },
                displayValueType: DisplayValueType.Numeral,
                shownValues: {
                    filter: "all"
                },
                sortBy: SortByTypes.Value
            },
            valueFormat: 3 }
    }),
    [WidgetType.TimeSeries]: (entity) => ({
        componentName: "InsChartWidget",
        componentProps: { chartType: "InsTimeSeriesChart",
            colorSet: "default",
            datapointParams: [defaultMeasureDimensionByEntity[entity]],
            pipelineParameter: {
                compositeObjectBuilder: {
                    measures: []
                },
                customVisitorsReducer: [
                    {
                        method: "highchartsTimeSeries"
                    }
                ],
                datapointsVisitorsReducer: [
                    {
                        arguments: [
                            "ReferenceDate",
                            "Asc"
                        ],
                        method: "sortByDatapoint"
                    }
                ],
                nodesVisitorsReducer: [
                    {
                        method: "getLeafValuesVisitor"
                    }
                ]
            },
            showLegend: true,
            unstack: false,
            userSettings: {
                dataGranularity: DataGranularity.yearly
            } }
    })
};
